import React from 'react';
import { Container } from '@philips-internal/oswald-ui-core';
import { classNames, getLostProps, propagateData } from '@philips-internal/oswald-ui-utils';
import { PanelProperties } from './panel-types.js';
import './panel.css';
const PanelContainer = {
    name: '',
};
function getStyle(props) {
    return {
        alignItems: props.alignItems,
        background: props.background,
        border: props.border,
        borderRadius: props.borderRadius,
        boxShadow: props.boxShadow,
        flex: props.height ? undefined : 1,
        flexDirection: props.flexDirection,
        gap: props.gap,
        gridArea: props.gridArea,
        height: props.height,
        justifyContent: props.justifyContent,
        margin: props.margin,
        padding: props.padding,
    };
}
function Panel(props) {
    const { lightTheme = PanelProperties.lightTheme.defaultValue, visible = PanelProperties.visible.defaultValue, uuid = PanelProperties.uuid.defaultValue, } = props;
    if (!visible) {
        return null;
    }
    const className = classNames({
        'c-panel': true,
        't-light': Boolean(lightTheme),
        [`${props.className}`]: Boolean(props.className),
    });
    const { children, data, ...otherProps } = props;
    const lostProps = getLostProps(PanelProperties, otherProps);
    return (React.createElement(Container, { className: className, style: getStyle(props), uuid: uuid }, propagateData(children, data, lostProps)));
}
export { Panel, PanelContainer, };
export default Panel;
//# sourceMappingURL=panel.js.map